export default __webpack_public_path__ + "static/media/women-6.6a78d564.jpg";